import './orderReceipt.scss';

import React from 'react';

import OrderFrame from '../../components/IFrame/iFrame.jsx';
import type { PaymentDetails } from '../../store/actions';
import type { Requisition } from '../../types/requisition';
import ReceiptTemplate from './receiptTemplate';

const OrderReceipt = ({
  frame,
  paymentInfo,
  requisition,
}: {
  frame: string;
  paymentInfo: PaymentDetails;
  requisition: Requisition;
}) => {
  return (
    <OrderFrame id={frame} title={frame} name={frame} style={{ display: 'none' }}>
      {<ReceiptTemplate paymentInfo={paymentInfo} requisition={requisition} />}
    </OrderFrame>
  );
};

export default OrderReceipt;
